<div class="content">
  <app-svg-note-sign></app-svg-note-sign>
  <h4 class="title">{{ 'CHECKOUT.INVALID_OFFER_OVERLAY.TITLE' | translate }}</h4>
  <p class="info">{{ 'CHECKOUT.INVALID_OFFER_OVERLAY.INFO' | translate }}</p>
  <ul class="products">
    <li class="product" *ngFor="let offer of invalidOffers">
      <div class="img-wrap">
        <img [src]="offer.imageUrl" [alt]="offer.item.name" class="product-img">
      </div>
      <p class="product-name">{{ offer.item.name }}</p>
    </li>
  </ul>
  <button class="action-btn" mm-button (click)="onGoToCart()">
    {{ 'CHECKOUT.INVALID_OFFER_OVERLAY.ACTION.BACK_TO_CART' | translate }}
  </button>
</div>
